import React from 'react';
import Enrollment from './compoment/Enrollment';
import './css/enrollmentForm.css';

const EnrollmentForm = () => {
  return (
    <section id="enrollment" className="p-md-4 p-0">
      <div className="container my-sm-0 mb-sm-3  my-5">
        <div
          className="bg-enrollment"
          style={{
            backgroundImage: `url(./images/enrollment-form-2-steps.png), linear-gradient(to right, #051f38, #192b57, #1a2c58)`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right bottom, center',
            backgroundSize: 'auto, cover',
          }}
        >
          <Enrollment />
        </div>
      </div>
    </section>
  );
};

export default EnrollmentForm;
